import {
  OperatorContainsAnyOf,
  OperatorEquals,
  OperatorExactlyAllOf,
  OperatorExactlyAnyOf,
  OperatorExcludeAllOf,
  OperatorExcludeAnyOf,
  OperatorForAllOf,
  OperatorForAnyOf,
  OperatorIsAllOf,
  OperatorIsAnyOf,
  OperatorIsGreaterThan,
  OperatorIsLessThan,
  OperatorIsNotAnyOf,
  OperatorIsNotPresent,
  OperatorIsPresent,
  OperatorNot,
  OperatorNotEquals,
  OperatorSentimentNegative,
  OperatorSentimentNeutral,
  OperatorSentimentPositive,
} from 'v2/core/services/queryBuilder/operators';
import { getFilterValueType } from './getFilterValueType';

interface GetFieldOperatorsParams {
  field: string;
  filterValueType?: ReturnType<typeof getFilterValueType>;
}

export function getFieldOperators({
  field,
  filterValueType,
}: GetFieldOperatorsParams) {
  const isNumberVariant =
    filterValueType === 'number' || filterValueType === 'number[]';

  switch (field) {
    case 'entity':
    case 'reason':
      return [
        OperatorIsAnyOf,
        OperatorIsAllOf,
        OperatorNot,
        OperatorIsPresent,
        OperatorIsNotPresent,
      ];
    case 'l1':
      return [OperatorIsAnyOf, OperatorIsAllOf, OperatorNot];
    case 'entitySentiment':
      return [
        OperatorSentimentNegative,
        OperatorSentimentNeutral,
        OperatorSentimentPositive,
      ];
    case 'language':
    case 'source':
    case 'sentiment':
    case 'reviewSentiment':
      return [OperatorIsAnyOf, OperatorIsNotAnyOf];
    case 'search':
      return [
        OperatorForAnyOf,
        OperatorForAllOf,
        OperatorExactlyAnyOf,
        OperatorExactlyAllOf,
        OperatorExcludeAnyOf,
        OperatorExcludeAllOf,
      ];
    case 'feedback':
      return [OperatorIsPresent, OperatorIsNotPresent];
    case 'category':
      return [OperatorIsAnyOf];
    case 'summary':
      return [OperatorIsPresent, OperatorIsNotPresent];
    default:
      return isNumberVariant
        ? [
            OperatorEquals,
            OperatorNotEquals,
            OperatorIsGreaterThan,
            OperatorIsLessThan,
            OperatorIsPresent,
            OperatorIsNotPresent,
            OperatorContainsAnyOf,
          ]
        : [
            OperatorIsAnyOf,
            OperatorIsNotAnyOf,
            OperatorIsPresent,
            OperatorIsNotPresent,
            OperatorContainsAnyOf,
          ];
  }
}
